import "./navbar.css";

import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import React, { useState, useEffect } from "react";

import logo from "../../img/logo/favicon.png";
import menu from "../../img/icons/menu.svg";

function Navbar() {
  const location = useLocation();

  const [isNavbarOpen, setIsNavbarOpen] = useState(false);

  useEffect(() => {
    const openNavbar = (event) => {
      if (event.target.tagName !== "BUTTON") {
        setIsNavbarOpen(false);
      }
    };

    document.addEventListener("click", openNavbar);

    return () => {
      document.removeEventListener("click", openNavbar);
    };
  }, []);

  return (
    <header className="navbar">
      <div className="navbar-box">
        <Link
          to="/"
          className="navbar-logo"
          onClick={() => {
            window.scroll(0, 0);
          }}
        >
          <img src={logo} alt="logo"></img>
          <p>GLOBAL TYRES RECYCLING LTD</p>
        </Link>

        <ul className="navbar-links">
          <li>
            <a href="#Services01">OUR SERVICES</a>
          </li>

          <li>
            <a href="#Products01">PRODUCTS</a>
          </li>

          <li>
            <a href="#About01">ABOUT</a>
          </li>

          <li>
            <a href="#Faq01">FAQ</a>
          </li>
          <li>
            <a href="#Cta01">CONTACT</a>
          </li>
        </ul>

        <button
          className="navbar-mobile-button"
          onClick={() => setIsNavbarOpen(true)}
        ></button>
      </div>

      <div
        className="navbar-mobile"
        style={{
          transform: isNavbarOpen ? "translateY(0)" : "translateY(-200px)",
          transition: "300ms",
        }}
      >
        <ul className="navbar-mobile-links">
          <li>
            <a href="#Services01">OUR SERVICES</a>
          </li>

          <li>
            <a href="#Products01">PRODUCTS</a>
          </li>

          <li>
            <a href="#About01">ABOUT</a>
          </li>

          <li>
            <a href="#Faq01">FAQ</a>
          </li>
          <li>
            <a href="#Cta01">CONTACT</a>
          </li>
        </ul>
      </div>
    </header>
  );
}

export default Navbar;
